export const getCSRFToken = () => {
  return document.getElementsByName("csrf-token")[0].content
}
